import React, { useState } from 'react'
import { CCollapse } from '@coreui/react-pro'
import { convertDateToDotDate } from '../../../../../utils/sharedFunctions'

export default function PanelCodeHistoryDisplay({ date, codes, display }) {
  const [shouldShow, setShouldShow] = useState(false)

  return (
    <>
      <div
        className={
          'd-flex justify-content-between align-items-center p-2 pt-3 panelCodeHistoryDisplay'
        }
        onClick={() => setShouldShow((prev) => !prev)}
      >
        <div>{convertDateToDotDate(date)}</div>
        {shouldShow ? (
          <i className="fa-solid fa-chevron-up"></i>
        ) : (
          <i className="fa-solid fa-chevron-down"></i>
        )}
      </div>
      <CCollapse visible={shouldShow}>{display(codes)}</CCollapse>
    </>
  )
}
